import { middlewareService } from '../../../src/shared/service';

export const consentService = {
 getConsent,
 sendConsent
}

function getConsent(type) {
  let url = getUrl(type);
  return middlewareService.getApiData(url)
}

function sendConsent(type,payload) {
  let url = getAcceptUrl(type)
  return middlewareService.postApiData(url,payload);
}

function getUrl(type) {
  switch (type) {
    case "kyc":
      return "/tnc/signup"
    case "checkout":
      return "/tnc/checkout"
    case "cas":
      return "/tnc/casupload"
  }
}

function getAcceptUrl(type) {
  switch (type) {
    case "kyc":
      return "/tnc/signup/accept"
    case "checkout":
      return "/tnc/checkout/accept"
    case "cas":
      return "/tnc/casupload/accept"
  }
}